import { Link } from 'react-router-dom';

import styled, { css } from 'styled-components';

import { getColorStyle } from 'styles/components/getColorStyle';
import theme from 'styles/token/color';
import { typography } from 'styles/token/typography';

export const arrowTransition = css`
  transition: all 0.3s ease-in-out;

  .arrow,
  .arrow-top {
    width: auto;
    font-size: 1em;
    transition: transform 300ms ease-out;
  }

  .arrow {
    margin-left: 6px;
  }

  .arrow-top {
    margin-left: 4px;
  }

  &:hover {
    cursor: pointer;
    .arrow {
      transform: translateX(4px);
    }
    .arrow-top {
      transform: translate(2px, -2px);
    }
  }
`;

export const textHoverTransition = css`
  p {
    transition: all 0.3s ease-in-out;
  }
  &:hover {
    cursor: pointer;
    p {
      color: ${theme.color.primary};
    }
  }
`;

const LinkText = styled.a`
  && {
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  display: inline;
  letter-spacing: -0.15px;
  height: auto;
  font-weight: 400;
  font-size: 14px;
  color: ${theme.color.primary};
  ${({ color }) => color && getColorStyle(color)}

  &:hover {
    text-decoration: underline;
  }
`;

const LinkIconText = styled.a`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  text-decoration: none;
  font-weight: 400;
  font-size: 14px;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 3px; /* 조절 가능 */
    width: 100%;
    height: 1px;
    background-color: currentColor;
  }
  ${({ color }) => color && getColorStyle(color)}
`;

const ModalLinkText = styled(LinkText)`
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const PText = styled.p`
  font-size: 14px;
  line-height: 23px;
  ${({ color }) => color && getColorStyle(color)}
  ${({ weight }) =>
    weight &&
    css`
      font-weight: ${weight};
    `};

  ${({ size }) =>
    size &&
    css`
      font-size: ${size}px;
    `};

  ${({ lineHeight }) =>
    lineHeight &&
    css`
      line-height: ${lineHeight}px;
    `};

  ${({ padding }) =>
    padding &&
    css`
      padding: ${padding};
    `};
`;

const SpanText = styled.span`
  letter-spacing: -0.15px;
  ${({ color }) => color && getColorStyle(color)}

  ${({ weight }) =>
    weight &&
    css`
      font-weight: ${weight};
    `};

  ${({ size }) =>
    size &&
    css`
      font-size: ${size}px;
    `};
`;

// 강조 텍스트 스타일
const StrongText = styled.strong`
  color: ${theme.color.descAct};
  font-weight: 450;

  &.primary {
    color: ${theme.color.primary};
    font-weight: 400;
  }
  &.underline {
    color: ${theme.color.primary};
    text-decoration: underline;
    font-weight: 400;
    a {
      color: ${theme.color.primary};
    }
  }
`;

const SpanTextTitle = styled(SpanText)`
  word-break: keep-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  color: ${theme.color.gray900};
  ${typography.titleMedium};
`;

const SpanTextDate = styled(SpanText)`
  margin-top: 6px;
  color: ${theme.color.gray600};
  ${typography.bodyExtraSmall};
`;

const SpanTextDesc = styled(SpanText)`
  margin-top: 4px;
  color: ${theme.color.gray400};
  ${typography.bodySmall};
`;

SpanText.Title = SpanTextTitle;
SpanText.Date = SpanTextDate;
SpanText.Desc = SpanTextDesc;

const HoverLink = styled(Link)`
  text-decoration: none;

  ${arrowTransition}
`;

export const text = {
  Link: LinkText,
  LinkIcon: LinkIconText,
  ModalLink: ModalLinkText,
  P: PText,
  Span: SpanText,
  Strong: StrongText,
  HoverLink,
};
